export default {
  common: {
    userSearchNoOptions: 'no hits',
  },
  form: {
    replacementQuestion_sv_primary_written:
      'Have you written a laudatur or eximia in the mother tongue (Swedish) matriculation examination, or are you otherwise a skilled and self-directed writer?',
    replacementQuestion_en_secondary_any:
      'I feel that I have already acquired the knowledge and skills corresponding to the studies included in my degree in my previous studies / work life / free time (CEFR B2).',
    replacementQuestion_sv_secondary_any:
      'I feel that I have already acquired the knowledge and skills corresponding to the studies included in my degree in my previous studies / work life / free time (CEFR B1).',
    mentoringQuestion_fi_secondary_any:
      'Do you want to practice everyday conversations together with others and review basic grammar before attending the Finnish course that is part of the exam?',
    finmuMentoringQuestion_fi_secondary_any:
      'Do you want to practice speaking and writing in Finnish about current topics and your studies together with other students?',
    challengeQuestion_fi_secondary_any:
      "Are you so anxious about using the Finnish language that you can't participate in a course where the language is practiced together with others?",
    previoslyDoneLangExplanation:
      '\nThe compulsory language and communication studies of the degree can be replaced by equivalent studies included in a previous domestic higher education degree and other equivalent previous achievements.\n',
    searchedLanguageExplanation:
      "\nAll bachelor's degrees include at least 10 credits of compulsory language and communication studies. The studies are completed according to your language of education as follows:\n\n- Mother tongue (Finnish/Swedish) 3 cr\n- Second national language (Swedish/Finnish) 3 cr\n- Foreign language (starting level in English CEFR B2, in other languages CEFR B1) 4 cr\n",
    primaryLanguageQuestion: 'What is your language of instruction?',
    languageQuestion: 'What language are you looking for?',
    primaryLanguageSpecificationQuestion: 'Which primary language type do you want to choose?',
    previouslyDoneLangQuestion:
      'I have completed similar studies or other equivalent achievements in a previous domestic higher education degree (completed or incomplete).',
    studyPeriodQuestion: 'What is the date of your desired course?',
    replacementQuestion:
      'I feel that I have already acquired knowledge and skills equivalent to those included in my degree in my previous studies / working life / leisure time.',
    mentoringQuestion: 'Do you need practice before completing a course that is part of your degree?',
    challengeQuestion: 'For me, learning a language is particularly challenging and it makes me very nervous/scared.',
    graduationQuestion: 'Are you graduating within six months?',
    studyPlaceQuestion: 'Which form of study suits you best?',
    integratedQuestion: 'I am interested in a course that is integrated into the studies in my field.',
    independentQuestion: 'I want to work independently or autonomously.',
    flexibleQuestion: 'I want to take a course with a flexible schedule',
    moocQuestion: 'Do you want to search for MOOCs (Massive Open Online Courses)?',
    collaborationQuestion: 'Show collaboration partner courses',
    multiPeriodQuestion: 'Search for courses that span multiple periods',
    finnish: 'finnish',
    swedish: 'swedish',
    english: 'english',
    yes: 'Yes',
    no: 'No',
    yesDefinitely: 'Yes (definitely)',
    noDefinitely: 'No (definitely)',
    neutralChoice: "I don't care",
    both: 'Both',
    'language-both': 'Written and verbal communication',
    written: 'Written communication',
    spoken: 'Verbal communication',
    summer: 'Summer',
    intensivePeriod1: 'Intensive Period 1',
    intensivePeriod2: 'Intensive Period 2',
    period: 'Period',
    periods: 'Periods',
    mentoringQuestionYes: 'I would like to have a litle bit of training before starting my studies',
    mentoringQuestionNo: 'I dont think that i need training',
    graduationQuestionYes: 'Yes, within half a year.',
    graduationQuestionNo: 'I am not graduating within half a year.',
    studyPlaceRemote: 'Studies that include remote sessions',
    studyPlaceOnline: 'Independent online study',
    studyPlaceCombined: 'Distance learning and face-to-face teaching',
    studyPlaceF2F: 'Studies that include face-to-face sessions',
    studyPlaceNeutral: 'The form of study does not matter',
    primaryLanguageExplanation:
      '\nYour language of education affects the completion of your studies.\n\nRead more detailed instructions on the Study Service page\n[What is your language of education?](https://studies.helsinki.fi/ohjeet/artikkeli/mika-koulusivistyskieleni)\n',
    replacementQuestion_fi_primary_written:
      'Have you written a laudatur or eximia in the mother tongue (Finnish) (or S2) matriculation examination, or are you otherwise a skilled and self-directed writer?',
    replacementQuestion_fi_secondary_any:
      'Are you bilingual (Finnish - Swedish) or do you use Finnish a lot and fluently in your studies and/or in other areas of your life?',
    challengeQuestion_fi_primary_written:
      'Is it difficult for you to participate in implementations that include attendance or joint online meetings due to your life situation or anxiety?',
    challengeQuestion_fi_primary_spoken:
      'I find social situations scary and I get very nervous in different interaction situations.',
    points: 'accuracy',
  },
  question: {
    extrainfo: 'Extra information',
    checkInstructionsCrediting:
      'Read more detailed instructions on the Study Service page [Recognition of communication and language studies for a degree and apply for substitution of studies in Sisu](https://studies.helsinki.fi/ohjeet/artikkeli/opintojen-ja-osaamisen-hyvaksilukeminen?check_logged_in=1)',
    fromHere: 'from here',
    noExtrainfo: 'No extra information',
    noOrganisation: 'No faculty found',
    pickStudy: 'Select a faculty',
    skipped: 'Question skipped: no effect',
    mandatory: 'Mandatory',
    close: 'Close',
  },
  app: {
    logout: 'Log out',
    questionaire: 'Questionaire',
    recommendations: 'Recommendations',
    send: 'Send',
    back: 'Back',
  },
  recommendations: {
    accurate: 'The most accurate recommendations:',
    all: 'all recommendations (accuracy may vary):',
    pointbased: 'Point-based recommendations',
  },
  v2: {
    periodFilter: {
      title: 'Period',
    },
    retakeQuestions: 'Answer starting questions',
    openFilters: 'Open filters',
    closeFilters: 'Close filters',
    opensInNewWindow: 'opens in a new window',
    moreOptions: 'More options',
    filtersRegion: 'Course filters',
    appDescription:
      'Polku is the University of Helsinki Language Centre course recommender. It suggests language and communication courses that fit your studies. Start by answering the initial questions about your study right and language of education, then narrow the suggestions down with the questions in the Course filters navigation. The suggestions update as soon as you change an answer, and the number of matching courses is announced in the Course recommendations region.',
    filter: {
      noMatches: 'no matching courses',
      matchCount_one: '{{count}} matching course',
      matchCount_other: '{{count}} matching courses',
      removeSelection: 'Remove selection {{selection}}',
      mandatoryStaysOpen: 'Stays open until you answer this mandatory question',
    },
    languageSelector: 'Language',
    universityLogoAlt: 'University of Helsinki',
    modal: {
      close: 'Close',
      warning: 'Warning',
    },
    skipQuestions: 'Skip questions',
    done: 'Done',
    welcomeText: 'First, answer a few initial questions. You can modify these later.',
    results: {
      heading: 'Course recommendations',
      loading: 'Loading course recommendations',
      loadingFilters: 'Loading filters',
      unansweredMandatory_one: 'Answer the remaining mandatory question: {{question}}',
      unansweredMandatory_other: 'Answer the {{count}} remaining mandatory questions, next: {{question}}',
      count_one: '{{count}} course found',
      count_other: '{{count}} courses found',
    },
    noRecommendations: {
      title: 'No courses found',
      unansweredMandatory: 'Answer the remaining mandatory question',
      openFilterQuestion: 'Open filters: {{question}}',
      changeSelectionsButton: 'Change your selections',
      resetButton: 'Clear choices',
      resetConfirmationTitle: 'Reset all selections?',
      resetConfirmationDescription: 'This will clear your current answers and restore the default filters.',
      resetConfirmationCancel: 'Cancel',
      resetConfirmationConfirm: 'Reset selections',
    },
    appTitle: 'Polku',
    adminButton: 'ADMIN',
    courseTags: {
      title: 'Course tags',
      course: 'Course',
      matched: '{{count}} courses match the current search',
      columns: 'Tag columns ({{shown}}/{{total}})',
      columnsAll: 'All',
      columnsStudy: 'Study tags',
      columnsFaculty: 'Faculty tags',
      cancel: 'Cancel',
      close: 'Close',
      state: {
        inherited: 'inherited from course unit',
        customCodeUrn: 'from a Sisu custom code urn',
        added: 'added on this realisation',
        both: 'in both apparaatti and Sisu',
        ignored: 'ignored on this realisation',
        unset: 'not set',
      },
      editing: {
        label: 'Editing',
        new: 'New version',
        newTitle: 'Create a new version',
        newConfirm: 'Create version',
        published: 'The applied version (read-only)',
        readOnly: 'The applied version cannot be edited. Pick or create a version to edit tags.',
        editingVersion: 'Editing version "{{name}}". Changes are saved into it immediately.',
      },
      publish: {
        liveVersion: 'The version in use is "{{name}}".',
        liveUnknown: 'The tagging in use is not saved as any version.',
        publishVersion: 'Review and apply',
        reviewTitle: 'Review the changes before applying',
        confirmApply: 'Apply these changes',
        nameLabel: 'Version name',
        nameHelp: 'Left empty, the version is named after the time it was created.',
        descriptionLabel: 'Description (optional)',
        descriptionHelp: 'Stored with the version.',
      },
      tabs: {
        realisations: 'Realisations',
        matched: '{{count}} course units in the current search',
        courseUnits: 'Course units',
        vocabulary: 'Tags',
        snapshots: 'Versions',
      },
      bulk: {
        open: 'Bulk apply tags',
        title: 'Apply tags to every matching course',
        tags: 'Tags',
        tagsHint: 'Type to filter, press Enter to pick the highlighted tag',
        mode: {
          add: {
            label: 'Add',
            description: 'Gives every matching course this tag.',
          },
          ignore: {
            label: 'Ignore',
            description:
              'Marks the tag as ignored on every matching course, so a tag inherited from the course unit stops applying to them.',
          },
          clear: {
            label: 'Clear',
            description:
              "Removes the course's own add or ignore setting, so the tag is decided by its course unit again.",
          },
        },
        newTagNote: 'Only existing tags can be applied. Create a new tag first in the Tags tab.',
        explanation: 'This applies to every course matching the current search, not only the visible page.',
        previewPending: 'Pick at least one tag to see how many courses would change.',
        previewCount: '{{count}} courses match.',
        confirm: 'Apply to all {{count}} matching courses',
      },
      cu: {
        explanation:
          'Tags set here are inherited by every realisation of the course unit. A realisation can ignore an inherited tag.',
        courseCode: 'Course code',
        courseUnit: 'Course unit',
        realisations: 'Realisations',
      },
      vocabulary: {
        key: 'Key',
        description: 'Description',
        add: 'Add tag',
        delete: 'Delete',
        deleteConfirm: 'Delete the tag {{key}}? Every course unit and realisation assignment of it is deleted too.',
        duplicate: 'A tag with this key already exists.',
        invalid: 'Invalid tag key.',
      },
      snapshots: {
        name: 'Version name',
        description: 'Description',
        createdAt: 'Saved',
        save: 'Save version',
        compare: 'Compare',
        edit: 'Edit',
        editTaggingConfirm: 'Open version {{name}} for editing? The current draft is replaced by its contents.',
        activate: 'Put in use',
        activeShort: 'In use',
        activeIs: 'In use: {{name}}',
        activeUnknown: 'In use: tagging that is not saved as any version',
        activateConfirm:
          'Put the version {{name}} in use? It replaces the current tagging and goes straight into recommendations.',
        restore: 'Restore',
        delete: 'Delete',
        empty: 'No saved versions yet.',
        restoreConfirm: 'Restore the tagging saved as {{name}}? The current state is saved as a version first.',
        deleteConfirm: 'Delete this version?',
        export: 'Export',
        import: 'Import',
        exportFailed: 'Export failed',
        importFailed: 'Import failed',
        importConfirm: 'Import {{fileName}}? This replaces all current tag assignments.',
        diffTitle: 'Differences against the current tagging',
        diffUnchanged: 'The current tagging is identical to this version.',
        diffVocabularyChanges: 'Changes to the tag vocabulary',
        diffCourseChanges: 'Changes to course tags',
        diffRealisationChanges: 'Changes to single realisation tags',
        diffBefore: 'Before: {{tags}}',
        diffNoTags: 'no tags',
        diffUnknownCourse: 'Course not found',
        diffLoading: 'Loading course names...',
      },
    },
    adminNav: {
      back: 'Back',
      backToApp: 'Back to app',
      overview: 'Overview',
      courses: 'Courses',
      stats: 'Stats',
      feedback: 'User feedback',
      loginAs: 'Login as',
      updater: 'Updater',
      courseTags: 'Course tags',
      errorTest: 'Error test',
    },
    admin: {
      loading: 'Loading...',
      settingsTabs: {
        texts: 'Text settings',
        filters: 'Filter settings',
        codes: 'Course codes',
        languages: 'Language categories',
      },
      recommendationCodes: {
        title: 'Recommended course codes',
        intro:
          'The course codes recommended for each faculty and language choice. A course only shows up in recommendations once its realisation is tagged in Sisu with the faculty kk-apparaatti code.',
        loading: 'Loading...',
        newCode: 'Add a code',
        editCode: 'Edit code',
        organisation: 'Faculty',
        language: 'Language',
        courseCode: 'Course code',
        courseCodeHelp: 'For example KK-ENERI. Allowed characters: letters, numbers, hyphen, slash and dot.',
        search: 'Search course code',
        matrixIntro:
          'One row per course code. A tick means the code is recommended for that faculty. Clicking adds or removes the code immediately, and clicking the same box again restores it.',
        coverage: '{{count}} / {{total}}',
        coverageHeader: 'Faculties',
        toggleCell: '{{courseCode}} — {{faculty}}',
        allValues: 'All',
        anyValue: 'Any',
        save: 'Save',
        cancel: 'Cancel',
        saveFailed: 'Saving failed',
        export: 'Export',
        exportFailed: 'Export failed',
        import: 'Import',
        importConfirm: 'Import codes from {{fileName}}?',
        importFailed: 'Import failed',
        importCompleted: 'Imported {{count}} codes',
        parseFailed: 'Could not read the file',
        languagesTitle: 'Language categories',
        languagesIntro:
          'A language category says which language answers its course codes apply to. The name is only for display, matching is driven by the language, type and specification.',
        languageIntro:
          'The name is only shown in the interface. Language, type and specification decide when this category is recommended.',
        languageName: 'Name',
        newLanguage: 'Add a language category',
        editLanguage: 'Edit language category',
        deleteLanguage: 'Delete language category',
        confirmDeleteLanguage: 'Delete the language category {{name}}?',
        lang: 'Language',
        languageType: 'Type',
        specification: 'Specification',
        langOption: {
          fi: 'Finnish',
          sv: 'Swedish',
          en: 'English',
        },
        languageTypeOption: {
          primary: 'Mother tongue',
          secondary: 'Second national language',
        },
        specificationOption: {
          spoken: 'Speech communication',
          written: 'Written communication',
        },
        table: {
          actions: 'Actions',
          codeCount: 'Codes',
        },
      },
      errorTest: {
        pageTitle: 'Error test',
        description:
          'Trigger a deliberate error to verify that error reporting works. Errors are only sent to Sentry in production.',
        backendOk: 'Backend responded successfully — no error was triggered.',
        backendTriggered: 'Backend error triggered (status {{status}}).',
        frontendTriggered: 'Frontend error thrown.',
        causeBackend: 'Cause error in backend',
        causeFrontend: 'Cause error in frontend',
      },
      courses: {
        pageTitle: 'KK- Courses',
        total: 'Showing only realisations whose course code starts with KK-. Total: {{total}}',
        loading: 'Loading courses...',
        visit: 'Visit',
        table: {
          name: 'Course Name',
          codes: 'Course Codes',
          customUrns: 'Custom URNs',
          dates: 'Dates',
          review: 'Review',
          reviewUpdated: 'Review Updated',
          actions: 'Actions',
        },
        search: {
          nameLegend: 'Name',
          nameField: 'Search',
          urnLegend: 'URN',
          includeLegend: 'Include',
          excludeLegend: 'Exclude',
          urnsToInclude: 'URNs to include',
          urnsToExclude: 'URNs to exclude',
          includeOrTitle: 'Keep courses matching any of the URNs listed to the left',
          includeAndTitle: 'Keep only courses matching all of the URNs listed to the left',
          excludeOrTitle: 'Drop courses matching any of the URNs listed to the left',
          excludeAndTitle: 'Drop only courses matching all of the URNs listed to the left',
          tagLegend: 'Tags',
          tagsToInclude: 'Tags to include',
          tagsToExclude: 'Tags to exclude',
          tagIncludeOrTitle: 'Show courses carrying any of the tags listed to the left',
          tagIncludeAndTitle: 'Show only courses carrying all of the tags listed to the left',
          tagExcludeOrTitle: 'Drop courses carrying any of the tags listed to the left',
          tagExcludeAndTitle: 'Drop only courses carrying all of the tags listed to the left',
          courseCodeLegend: 'Course code',
          courseCodeInclude: 'Include',
          courseCodeExclude: 'Exclude (comma-separated)',
          reviewLegend: 'Review',
          statusField: 'Status',
          statusAll: 'All',
          statusReviewed: 'Reviewed',
          statusNotReviewed: 'Not reviewed',
          courseDateLegend: 'Course date',
          courseDateTooltip: 'Keeps only courses that both start and end within the range',
          from: 'From',
          to: 'To',
          submit: 'Search',
        },
      },
      review: {
        reviewed: 'Reviewed',
        notReviewed: 'Not reviewed',
        commentPlaceholder: 'Add comment',
        saved: 'Review saved',
        saveButton: 'Save review',
        saveFailed: 'Failed to save review',
      },
      stats: {
        pageTitle: 'Usage Stats',
        legendHint: 'Click a legend item, a bar or a slice to hide that organisation.',
        hideAll: 'Hide all',
        showAll: 'Show all',
        start: 'Start',
        end: 'End',
        groupBy: 'Group by',
        hour: 'Hour',
        day: 'Day',
        month: 'Month',
        year: 'Year',
        last14Days: 'Last 14 days',
        exportCsv: 'Export CSV',
        csv: {
          period: 'Period',
          faculty: 'Faculty',
          phase1: "Bachelor's programme",
          phase2: "Master's programme",
          count: 'Users',
        },
        uniqueUsers: 'Unique users',
        faculty: 'Faculty',
        loading: 'Loading stats...',
        noVisits: 'No visits in the selected range.',
        programmes: {
          title: 'Study programme',
          phase1: "Bachelor's programme",
          phase2: "Master's programme",
          unknown: 'Unknown',
          noData: 'No study programme data in the selected range.',
        },
      },
      backendLocales: {
        loading: 'Loading texts...',
        title: 'Texts served from the backend',
        intro:
          'Texts that can vary by faculty and language choices. Every key should have a catch-all text so that all users see something.',
        table: {
          key: 'Key',
          description: 'Description',
          textCount: 'Texts',
          textFi: 'Text (fi)',
          actions: 'Actions',
        },
        anyValue: 'any',
        organisation: 'Faculty',
        lang: 'Course language',
        primaryLanguage: 'Language of education',
        specification: 'Completion type',
        langOption: {
          fi: 'Finnish',
          sv: 'Swedish',
          en: 'English',
        },
        specificationOption: {
          writtenAndSpoken: 'written and spoken',
          written: 'written',
          spoken: 'spoken',
        },
        specificationHelp:
          'The completion type is only asked from the user when the course language is the same as the language of education.',
        specificationUnreachable:
          'With these language choices the completion type is never asked from the user, so it is forced to "any".',
        newKey: 'New key',
        editKey: 'Edit key',
        deleteKey: 'Delete key',
        keyLabel: 'Key',
        keyHelp: 'The identifier used in the code, for example noRecommendations.additionalInfo',
        descriptionHelp: 'Describe where this text is shown to the user. Write in whichever language you prefer.',
        descriptionLabel: 'Description',
        newText: 'New text',
        editText: 'Edit text',
        deleteText: 'Delete text',
        textLabel: 'Text (markdown)',
        textToShow: 'Text to show',
        whenShown: 'When the text is shown',
        preview: 'Preview',
        toggleTexts: 'Show texts for key {{key}}',
        noCatchAll: 'no catch-all text, some users will see nothing',
        save: 'Save',
        cancel: 'Cancel',
        saveFailed: 'Saving failed',
        confirmDeleteKey:
          'Delete the key {{key}} and its {{count}} texts? The code using the key will start logging an error.',
        confirmDeleteValue: 'Delete this text?',
        export: 'Export JSON',
        import: 'Import JSON',
        exportFailed: 'Export failed',
        importConfirm: 'Import the file {{fileName}}? Existing texts will be updated.',
        importFailed: 'Import failed',
        importCompleted: 'Import complete: {{count}} keys processed.',
        parseFailed: 'Could not read the file',
      },
      filterConfig: {
        loading: 'Loading filters...',
        title: 'Filter Configuration',
        table: {
          order: 'Order',
          id: 'ID',
          shortNameFi: 'Short Name (fi)',
          enabled: 'Enabled',
          actions: 'Actions',
        },
        edit: 'Edit',
        restore: 'Restore',
        restoring: 'Restoring...',
        addFilter: '+ Add filter',
        export: 'Export Configuration',
        import: 'Import Configuration',
        restoreConfirm: 'Restore this filter to seeded defaults? This will overwrite current settings.',
        noSeedDefaults: 'This filter has no seeded defaults to restore',
        restoreFailed: 'Failed to restore filter defaults',
        exportFailed: 'Failed to export filter configuration',
        importConfirm:
          'Import filter configuration from {{fileName}}?\n\nThis will update existing filters with the imported settings.',
        importFailed: 'Failed to import filter configuration',
        importCompleted:
          'Import completed:\n{{updated}} filters updated\n{{skipped}} filters skipped\n{{errors}} errors',
        parseFailed: 'Failed to parse or import file',
      },
      filterEdit: {
        createTitle: 'Create filter',
        editTitle: 'Edit: {{id}}',
        tabGeneral: 'General',
        tabVariants: 'Variants ({{amount}})',
        cancel: 'Cancel',
        save: 'Save',
        unknownError: 'Unknown error',
        networkError: 'Network error',
        id: 'ID',
        idHelper: 'Lowercase alphanumeric + hyphens',
        displayType: 'Display type',
        displayTypeNone: '— none —',
        displayOrder: 'Display order',
        parentFilterId: 'Parent filter ID (optional)',
        mandatory: 'Mandatory',
        showInWelcomeModal: 'Show in welcome modal',
        hideInCurrentFiltersDisplay: 'Hide in current filters',
        hideInFilterSidebar: 'Hide in sidebar',
        enabled: 'Enabled',
        shortName: 'Short name',
        explanation: 'Explanation (optional)',
        explanationHint: '(the question icon)',
        extraInfo: 'Extra info (optional)',
        extraInfoHint: '(shown when display type is info-only)',
        language: 'Language',
        langFi: 'Finnish',
        langSv: 'Swedish',
        langEn: 'English',
        optionId: 'Option ID',
        valueOverride: 'Value override',
        selectedByDefault: 'Selected by default',
        nullValue: '— null —',
        optionName: 'Name',
        variantName: 'Variant name',
        variantFallback: 'Variant {{number}}',
        skipped: 'Skipped',
        questionText: 'Question text',
        explanationOverride: 'Explanation override (optional)',
        explanationOverrideField: 'Explanation override',
        options: 'Options ({{amount}})',
        addOption: 'Add option',
        addVariant: 'Add variant',
      },
    },
    updater: {
      pageTitle: 'Updater',
      runButton: 'Run updater',
      coursesRunButton: 'Update courses',
      coursesConfirmBody: 'This updates only the course data. Other updater steps are skipped.',
      alreadyRunning: 'A run is already in progress.',
      confirmTitle: 'Run updater?',
      confirmBody:
        'This will trigger a full re-sync of all course, user and organisation data from the importer. The operation runs in the background and can take several minutes to complete.',
      confirmButton: 'Run',
      cancelButton: 'Cancel',
      runStarted: 'Updater run started.',
      runFailed: 'Failed to start updater run.',
      historyTitle: 'Run history',
      loading: 'Loading...',
      empty: 'No runs recorded yet.',
      table: {
        id: 'ID',
        status: 'Status',
        runtype: 'Run type',
        triggeredBy: 'Triggered by',
        started: 'Started',
        finished: 'Finished',
        duration: 'Duration',
        error: 'Error',
      },
      status: {
        running: 'Running',
        success: 'Success',
        failed: 'Failed',
      },
    },
    feedback: {
      openButton: 'Send feedback',
      title: 'Send feedback',
      description: 'Tell us how we can improve the service.',
      textLabel: 'Feedback',
      starsLabel: 'Stars',
      starsValue_one: '{{count}} star',
      starsValue_other: '{{count}} stars',
      starsEmpty: 'No rating',
      sendMetadata: 'send search data',
      sendMetadataInfo:
        'By selecting this, your filter selections and received search results are sent with the form. The feedback remains anonymous.',
      viewMetadata: 'View search data',
      metadataDialogTitle: 'Search data preview',
      metadataDialogDescription: 'This is the search data that can be sent with your feedback.',
      send: 'Send feedback',
      cancel: 'Cancel',
      sent: 'Feedback sent',
      failed: 'Failed to send feedback',
      sendContactEmail: 'Send contact information',
      sendContactEmailInfo:
        'This will attach your helsinki.fi email to the feedback. Use this if you want us to be able to respond back to your feedback. The feedback will not be anonymous if you choose this option.',
      attachedEmail: 'Attached email: {{email}}',
      admin: {
        backToAdmin: 'Back to admin',
        pageTitle: 'User feedback',
        start: 'Start',
        end: 'End',
        last12Months: 'Last 12 months',
        loading: 'Loading feedback...',
        empty: 'No feedback submitted yet.',
        readComment: 'Read',
        dialogTitle: 'Feedback comment',
        close: 'Close',
        starsValue: '{{stars}} / 5 stars',
        emailFilterLabel: 'Contact email',
        emailFilterAll: 'All',
        emailFilterHas: 'Has email',
        emailFilterNo: 'No email',
        emailSearchLabel: 'Search by email',
        table: {
          date: 'Date',
          stars: 'Stars',
          version: 'Version',
          email: 'Email',
          text: 'Text feedback',
          metadata: 'Metadata',
          hasMetadata: 'Yes',
          noMetadata: 'No',
          action: 'Action',
        },
        metadata: {
          title: 'Recommendation metadata',
          filterSelections: 'Filter selections',
          unnamedCourse: 'Unnamed Course',
          recommendations: 'Recommendations',
          points: 'Points',
          courseCodes: 'Course codes',
          period: 'Period',
        },
        massAction: 'Mass action',
        deleteOlderThanPreview: 'Removes {{count}} feedbacks',
        deleteSelected: 'Delete selected ({{count}})',
        deleteOlderThanLabel: 'Remove feedbacks older than',
        prefill180Days: '180 days ago',
        deleteOlderThanButton: 'Delete',
        confirmDeleteTitle: 'Confirm deletion',
        confirmDeleteBody: 'This will permanently delete {{count}} feedback entries. This cannot be undone.',
        confirmDeleteButton: 'Delete',
        deleteSuccess: 'Deleted {{count}} feedbacks',
        deleteError: 'Failed to delete feedbacks',
      },
    },
    loginPrompt: 'Please log in:',
    loginLink: 'here',
    loadingFilters: 'Loading filters...',
    sortBy: 'Sort by',
    sortRecommended: 'Recommended',
    sortName: 'Name',
    sortDate: 'Date',
    sortPeriod: 'Period',
    recommendationSearch: {
      label: 'Search courses by name',
      placeholder: 'Type a course name',
      resultsCount: 'Showing {{shown}} of {{total}} courses',
      noMatchesTitle: 'No matching courses found',
      noMatchesDescription: 'Try another course name or clear the search to see all recommended courses.',
      clearButton: 'Clear search',
    },
  },
  course: {
    show: 'Course page',
    showCourse: 'Course page: {{course}}',
    credits: 'cr',
    reasons: 'reasons',
    periodName: 'period',
    examWeek: 'Exam week',
    intensivePeriod: 'Intensive period',
  },
  opintotarjonta: {
    mooc: 'mooc',
  },
  loginAsPage: {
    title: 'user search',
    userHeader: 'user',
  },
  filter: {
    period: 'Period',
    periods: 'Periods',
    organisation: 'Organisation',
    language: 'Language',
    graduation: 'Graduation within six months',
    mentoring: 'Need practice before course',
    integrated: 'Interested in integrated course',
    studyPlace: 'Study Place',
    replacement: 'Acquired knowledge previously',
    challenge: 'Language learning challenging',
    independent: 'Want to work independently',
    flexible: 'Want flexible schedule',
    mooc: 'Search for MOOCs',
    finmu: 'FinMU related',
    multiPeriod: 'Course duration',
    allSelected: 'All',
  },
  filterShortName: {
    'Opinto-oikeus': 'Study Right',
    Koulukieli: 'School Language',
    Kurssi: 'Course',
    Viestintä: 'Communication',
    Aikaisemmatopinnot: 'Previous Studies',
    Korvaava: 'Replacement',
    Valmentava: 'Preparatory',
    Finmu: 'Finmu',
    Edistynyt: 'Custom',
    Valmistuville: 'For Graduating',
    Integroitu: 'Integrated',
    Itsenäinen: 'Independent',
    Opetusmuoto: 'Teaching Method',
    Lukuvuosi: 'Academic Year',
    Periodi: 'Period',
    MOOC: 'MOOC',
    'opintotarjonta:mooc': 'mooc',
    Yhteistyo: 'Collaboration',
    Kurssinpituus: 'Course Duration',
    Exam: 'Exam',
  },
}
